// config.js

// Symbol sets
export const stableSymbols = ["USDC", "USDbC", "USDT", "USDS", "DAI", "GHO"];
export const ethSymbols = ["wETH", "WETH"];
export const allSymbols = [...stableSymbols, ...ethSymbols];

// Vault addresses for stable coins
export const stableVaultAddressesByChain = {
  mainnet: [
    {
      address: "0xBEeFFF209270748ddd194831b3fa287a5386f5bC",
      label: "Smokehouse USDC",
    },
    {
      address: "0x8eB67A509616cd6A7c1B3c8C21D48FF57df3d458",
      label: "Gauntlet USDC Core",
    },
    {
      address: "0xBEEF01735c132Ada46AA9aA4c54623cAA92A64CB",
      label: "Steakhouse USDC",
    },
    {
      address: "0xcBC9B61177444A793B85442D3a953B90f6170b7D",
      label: "Apostro Resolve USDC (Euler)",
    },
    {
      address: "0x500331c9fF24D9d11aee6B07734Aa72343EA74a5",
      label: "Gauntlet DAI Core",
    },
    {
      address: "0x5C20B550819128074FD538Edf79791733ccEdd18",
      label: "Fluid USDT",
    },
    {
      address: "0x9Fb7b4477576Fe5B32be4C1843aFB1e55F251B33",
      label: "Fluid USDC",
    },
    {
      address: "0x0F359FD18BDa75e9c49bC027E7da59a4b01BF32a",
      label: "Relend USDC",
    },
    {
      address: "0x6A29A46E21C730DcA1d8b23d637c101cec605C5B",
      label: "Fluid GHO",
    },
    {
      address: "0x132E6C9C33A62D7727cd359b1f51e5B566E485Eb",
      label: "Resolv USDC",
    },
    {
      address: "0x3b028b4b6c567eF5f8Ca1144Da4FbaA0D973F228",
      label: "Tulipa Resolv USDC",
    },
    // {
    //   address: "0x08c6F91e2B681FaF5e17227F2a44C307b3C1364C",
    //   label: "Ether.Fi Liquid USD",
    // },
    {
      address: "0x182863131F9a4630fF9E27830d945B1413e347E8",
      label: "Yearn USDS",
    },
    {
      address: "0x5D409e56D886231aDAf00c8775665AD0f9897b56",
      label: "Compound v3 USDS",
    },
    {
      address: "0xd63070114470f685b75B74D60EEc7c1113d33a3D",
      label: "MEV Capital Usual USDC",
    },
    {
      address: "0x701907283a57FF77E255C3f1aAD790466B8CE4ef",
      label: "Index Coop hyETH",
    },
  ],
  base: [
    {
      address: "0xEdc817A28E8B93B03976FBd4a3dDBc9f7D176c22",
      label: "MoonWell USDC",
    },
    {
      address: "0x53E240C0F985175dA046A62F26D490d1E259036e",
      label: "Seamless USDC",
    },
    {
      address: "0xb125E6687d4313864e53df431d5425969c15Eb2F",
      label: "Compound V3 USDC",
    },
    {
      address: "0x12AFDeFb2237a5963e7BAb3e2D46ad0eee70406e",
      label: "Re7 USDC",
    },
    {
      address: "0x0A1a3b5f2041F33522C4efc754a7D096f880eE16",
      label: "Euler Base USDC",
    },
  ],
};

// Vault addresses for ETH
export const ethVaultAddressesByChain = {
  mainnet: [
    {
      address: "0x2371e134e3455e0593363cBF89d3b6cf53740618",
      label: "Morpho Gauntlet wETH prime",
    },
    {
      address: "0x4881Ef0BF6d2365D3dd6499ccd7532bcdBCE0658",
      label: "Morpho Gauntlet LRT Core wETH",
    },
    {
      address: "0x78Fc2c2eD1A4cDb5402365934aE5648aDAd094d0",
      label: "Morpho Re7 wETH",
    },
    {
      address: "0x9a8bC3B04b7f3D87cfC09ba407dCED575f2d61D8",
      label: "Morpho Mev Capital wETH",
    },
    {
      address: "0xBEEf050ecd6a16c4e7bfFbB52Ebba7846C4b8cD4",
      label: "Morpho Steakhouse ETH",
    },
    {
      address: "0xD8b27CF359b7D15710a5BE299AF6e7Bf904984C2",
      label: "Euler Prime wETH",
    },
    {
      address: "0x38989BBA00BDF8181F4082995b3DEAe96163aC5D",
      label: "Flagship ETH",
    },
    {
      address: "0x716bF454066a84F39A2F78b5707e79a9d64f1225",
      label: "Swaap Lend ETH",
    },
  ],
  base: [
    {
      address: "0xa0E430870c4604CcfC7B38Ca7845B1FF653D0ff1",
      label: "MoonWell Flagship ETH",
    },
    {
      address: "0x6b13c060F13Af1fdB319F52315BbbF3fb1D88844",
      label: "Gauntlet wETH Core",
    },
    {
      address: "0x46e6b214b524310239732D51387075E0e70970bf",
      label: "Compound v3 wETH",
    },
    {
      address: "0x859160DB5841E5cfB8D3f144C6b3381A85A4b410",
      label: "Euler Base wETH",
    },
  ],
};

// Protocol string => associated logo file name
export function getProtocolLogoText(protocolString) {
  if (!protocolString) return null;
  const lower = protocolString.toLowerCase();
  if (lower.includes("euler")) return "EulerLogo.png";
  if (lower.includes("fluid")) return "FluidLogo.png";
  if (lower.includes("morpho")) return "MorphoLogo.png";
  if (lower.includes("aave")) return "AaveLogo.png";
  if (lower.includes("moonwell")) return "MoonwellLogo.png";
  if (lower.includes("compound")) return "CompLogo.png";
  if (lower.includes("seamless")) return "SeamLogo.png";
  if (lower.includes("ether.fi")) return "Etherfi.png";
  if (lower.includes("yearn")) return "Yearn.png";
  return null;
}
